import api from '@/services/api'

/**
 * Composable do Serviço Central de Conversão de Quantidades.
 *
 * O backend é a fonte da verdade: o frontend NÃO calcula mais a conversão
 * fornecedor ↔ unidade básica. Ele chama o endpoint de simulação (read-only)
 * no lost focus do campo de quantidade ou no botão "Calcular".
 *
 * Regra (backend):
 *   - PermiteConversaoVariavel == false → recalcula a grandeza derivada.
 *   - PermiteConversaoVariavel == true  → preserva as duas grandezas informadas.
 */
export function useConversaoQuantidade () {
  /**
   * Chama o endpoint de simulação e devolve as quantidades canônicas.
   *
   * @param {Object} payload
   * @param {number} payload.idProduto
   * @param {number} [payload.idFornecedor]
   * @param {number} [payload.idProdutoFornecedor]
   * @param {number} [payload.quantidadeFornecedor]
   * @param {number} [payload.quantidadeBase]
   * @param {number} [payload.fatorConversao]
   * @param {'Fornecedor'|'Base'} [payload.campoOrigem]
   * @returns {Promise<{quantidadeFornecedor:number, quantidadeBase:number, fatorConversao:number, permiteConversaoVariavel:boolean}>}
   */
  const simular = async (payload) => {
    const response = await api.post('/ConversaoQuantidade/simular', payload)
    return response.data
  }

  return { simular }
}
